<template>
  <div class="lxm-main">
    <transition :name="transitionName" mode="out-in">
      <template v-if="menu">
        <lxm-menu></lxm-menu>
      </template>
      <template v-else-if="nav">
        <lxm-nav :title="navTitle"
                 :share="nav.share"
                 :menu="!nav.share"></lxm-nav>
      </template>
    </transition>

    <router-view></router-view>

    <transition name="lxm-transition-fade" mode="out-in">
      <template v-if="bottomBar">
        <template v-if="bottomBar.type === 'bottom-tabs'">
          <lxm-bottom-tabs></lxm-bottom-tabs>
        </template>
        <template v-else-if="bottomBar.type === 'close-notification'">
          <lxm-close-notification :highlight="bottomBar.highlight"
                                  :open="notification.open"
                                  :loading="notification.loading"
                                  @click="closeNotificationClicked"></lxm-close-notification>
        </template>
        <template v-else-if="bottomBar.type === 'prev-next'">
          <lxm-prev-next></lxm-prev-next>
        </template>
        <template v-else-if="bottomBar.type === 'contact-bottom-bar'">
          <lxm-contact-bottom-bar :phone="contact.phone"
                                  :address="contact.address"></lxm-contact-bottom-bar>
        </template>
      </template>
    </transition>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../styles/index.styl'
</style>

<script>
  import LxmNav from './common/LxmNav.vue'
  import LxmMenu from './common/LxmMenu.vue'
  import LxmBottomTabs from './common/LxmBottomTabs.vue'
  import LxmCloseNotification from './common/LxmCloseNotification.vue'
  import LxmPrevNext from './common/LxmPrevNext.vue'
  import LxmContactBottomBar from './common/LxmContactBottomBar.vue'
  import * as aTypes from '../../store/action-types'
  export default {
    components: {
      LxmNav,
      LxmMenu,
      LxmBottomTabs,
      LxmCloseNotification,
      LxmPrevNext,
      LxmContactBottomBar
    },
    computed: {
      transitionName () {
        return this.$store.getters.transitionName
      },
      pageTransitionName () {
        return this.$store.getters.pageTransitionName
      },
      navTitle () {
        return this.$store.state.navTitle
      },
      nav () {
        return this.$route.meta.nav
      },
      menu () {
        return this.$route.meta.menu
      },
      bottomBar () {
        return this.$route.meta.bottomBar
      },
      contact () {
        return this.$store.state.contact.contact
      },
      notification () {
        return this.$store.state.notification[this.bottomBar.key]
      }
    },
    mounted () {
      this.$store.dispatch(aTypes.GET_USER)
      this.$store.dispatch(aTypes.GET_TEAM_INFO)
    },
    methods: {
      closeNotificationClicked () {
        let id = null
        switch (this.bottomBar.key) {
          case 'formfill':
            id = this.$route.query.formId
            break
          case 'cf_donate':
            id = this.$route.query.projectId
            break
          case 'activity_signup':
            id = this.$route.query.activityId
            break
        }
        this.$store.dispatch(aTypes.TOGGLE_NOTIFICATION, { type: this.bottomBar.key, id })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?1fff643d